import React, { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { EditButton, TestButton, ActivateButton } from '../../components';
import { EditFactorModal } from '../../components/Modal/EditFactorModal/EditFactorModal';
import './index.scss';
import orangetick from '../../assets/images/orangetick.svg';
import upDownArrow from '../../assets/images/updownArrow.svg';
import twoFactorArrow from '../../assets/images/twofactorarrow.svg';
import infoSvgIcon from '../../assets/images/infoLiveTableIcon.svg';
import DataTable from 'react-data-table-component';
import ActiveDotIcon from './ActiveDotIcon';
// import * as $ from "jquery";
// import faCheck from '@fortawesome/free-solid-svg-icons/faCheck';

/*
function multiLabel(el, getStatus) {
  const { urlBase } = window.runConfig;
  var rows = [];
  for (var i = 1; i < el.labels.length; i++) {
    const src2 =
      urlBase + "api/v1/labels/" + el.labels[i].id + "?display_image=true";

    rows.push(
      <tr
        key={el.labels[i].id}
        className="d-flex justify-content-between"
        style={{ alignItems: "center" }}
      >
        <td style={{ border: "none" }}>
          <img
            alt="display"
            width="170"
            style={{ borderRadius: "10px" }}
            src={src2}
          />
        </td>
        <td style={{ border: "none", valign: "middle" }}>
          <small style={{ fontWeight: "500", fontSize: "14px" }}>
            {el.description}
          </small>
          <br />
        </td>
        <td style={{ border: "none" }}>
          <p style={{ fontWeight: "500", fontSize: "14px", margin: "0" }}>
            {getStatus(el)}
          </p>
        </td>
        <td style={{ paddingTop: "10px", border: "none" }}>
          <Link
            className="links"
            to={{
              pathname: "/dashboard/project",
              state: { projectId: el.id },
            }}
          >
            ...
          </Link>
        </td>
      </tr>
    );
  }

  return rows;
}
*/

const doThisEdit = (el, history) => {
  history.push({
    pathname: '/dashboard/editProject',
    state: { project: el },
  });
};

const ProjectsPage = ({ type, activate, test, projectsData, pending }) => {
  const history = useHistory();
  const [latestData, setLatestData] = useState([]);
  const { urlBase } = window.runConfig;
  const [drop, setDrop] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  // const src =
  //   urlBase + 'api/v1/labels/' + el.labels[0].id + '?display_image=true';

  // const showDropdown = el.labels.length > 1;

  // let numScans = 0;
  // let encryptions = 0;
  // el.labels.forEach((x) => {
  //   numScans += x.num_scans;
  //   encryptions += x.encryptions;
  // });
  const getTotalEncryptions = (row, field) => {
    let encryptions = 0;
    row.labels.forEach((label) => {
      encryptions += label[field];
    });
    return encryptions;
  };
  const customSort = (rows, field, direction) => {
    const sortedRows = [...rows.data]; // Create a shallow copy of the rows array
    sortedRows.sort((a, b) => {
      const valueA = getTotalEncryptions(a, field);
      const valueB = getTotalEncryptions(b, field);

      if (direction === 'asc') {
        return valueA - valueB;
      } else if (direction === 'desc') {
        return valueB - valueA;
      }

      return 0;
    });

    return { ...rows, data: sortedRows };
  };
  const [elementStates, setElementStates] = useState([]);

  const handleElementChange = (index) => {
    setElementStates((prevElementStates) => {
      const updatedElementStates = [...prevElementStates];
      updatedElementStates[index] = !updatedElementStates[index];
      return updatedElementStates;
    });
  };
  useEffect(() => {
    let newData = projectsData.filter(
      (el) =>
        el.id !== -1 &&
        el.labels.length > 0 &&
        el.labels[0].provisioning_status !== 'PROCESSING'
    );
    setLatestData(newData);
  }, [projectsData]);
  useEffect(() => {
    const initializeElementStates = () => {
      setElementStates(Array(latestData?.length).fill(false));
    };

    initializeElementStates();
  }, [latestData]);
  const getStatusEl = (el) => {
    if (el.state === 'ACTIVE') {
      return 'Active';
    } else if (el.state === 'INACTIVE') {
      return 'Inactive';
    } else {
      return 'PROJECT IN TEST';
    }
  };
  const columnss = [
    {
      name: 'Product Image',
      // selector: (row) => row.label,
      width: '10%', // Adjust the width percentage as needed
      cell: (row) => {
        const src =
          urlBase + 'api/v1/labels/' + row.labels[0].id + '?display_image=true';

        return (
          <div style={{ width: '100%', margin: '14px 0px' }}>
            <img
              alt="display"
              objectfit="cover"
              width="93px"
              height="83px"
              style={{
                borderRadius: '15px',
                backgroundColor: '#C4C4C4',
                backgroundSize: 'cover',
              }}
              src={src}
            />
          </div>
        );
      },
    },
    {
      name: 'Product Details',
      selector: (row) => row.id,
      sortable: true,
      width: '30%',
      cell: (row, index) => {
        return (
          <div className="d-flex flex-column">
            <p
              style={{
                color: '#090B0B',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '18px',
                margin: '0px',
              }}
            >
              {row.name}
            </p>
            <p
              style={{
                color: '#090B0B',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '18px',
                margin: '0px',
              }}
            >
              {' '}
              {row.description}{' '}
            </p>

            {elementStates[index] === true ? (
              <div>
                <span
                  // onClick={() => {
                  //   setDrop(!drop);
                  // }}
                  onClick={() => handleElementChange(index)}
                >
                  <img alt="tick" src={orangetick} width={17} /> &nbsp;
                  <small style={{ cursor: 'pointer' }}>
                    Multi Factor &nbsp;
                    <img
                      alt="display"
                      src={upDownArrow}
                      style={{
                        ponterEvents: 'auto',
                        cursor: 'pointer',
                        transform:
                          elementStates[index] === true ? 'rotate(180deg)' : '',
                        transition: '0.5s',
                      }}
                    />
                  </small>
                </span>
              </div>
            ) : null}
          </div>
        );
      },
    },
    {
      name: 'Total Factor',
      selector: (row) => 2,
      sortable: true,
      width: '7%',
      cell: (row) => {
        return (
          <>
            <div
              style={{
                width: '57px',
                height: '36px',
                background: '#F2F7FE',
                borderRadius: '6px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.7rem',
                cursor: 'pointer',
              }}
              onClick={() => setModalShow(true)}
            >
              02{' '}
              <img
                src={twoFactorArrow}
                alt="arrowimg"
                width="7px"
                // onClick={() => setModalShow(true)}
              ></img>
            </div>
            <EditFactorModal
              show={modalShow}
              onHide={() => setModalShow(false)}
            />
          </>
        );
      },
      headerCellClass: 'sortable-header',
    },
    {
      name: 'Encryptions',
      selector: (row) => {
        let encryptions = 0;
        row.labels.forEach((x) => {
          encryptions += x.encryptions;
        });
        return encryptions;
      },
      sortable: true,
      width: '7%',

      sortable: true,
      // sortFunction: customSort,
    },
    {
      name: 'Total Live Scans',
      width: '10%',
      selector: (row) => {
        let numScans = 0;
        row.labels.forEach((x) => {
          numScans += x.num_scans;
        });
        return numScans;
      },
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row) => {
        if (row.state === 'ACTIVE') {
          return true;
        } else {
          return false;
        }
      },
      cell: (row) => {
        return (
          <div
            style={{ color: row.state === 'ACTIVE' ? '#22C55E' : '#BCBFC9' }}
          >
            <span
              style={{
                backgroundColor:
                  row.state === 'ACTIVE' ? '#22C55E1A' : '#BCBFC91A',
                padding: '2px 6px',
                borderRadius: '16px',
                display: 'block',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: '10px',
              }}
            >
              <ActiveDotIcon
                fill={row.state === 'ACTIVE' ? '#22C55E' : '#BCBFC9'}
              />{' '}
              {getStatusEl(row)}
            </span>
          </div>
        );
      },
      sortable: true,
    },

    {
      name: '',
      cell: (row) => {
        return (
          <div>
            {type === 'PROCESSING' ? (
              <div className="btns-div">
                <div className="bottom-buttons">
                  <EditButton onclick={() => doThisEdit(row, history)} />
                </div>
              </div>
            ) : (
              <div className="btns-div">
                <ActivateButton
                  state={row.state !== 'ACTIVE' ? 'inactive' : 'active'}
                  label={row.state === 'ACTIVE' ? 'Deactivate' : 'Active'}
                  onclick={(e) => {
                    e.preventDefault();
                    activate(row);
                  }}
                  liveProject
                />
                <div className="bottom-buttons">
                  <EditButton
                    onclick={() => doThisEdit(row, history)}
                    editNone
                  />
                  {/* &nbsp;&nbsp; */}
                  <TestButton
                    state={row.state === 'TEST' ? 'on' : 'off'}
                    onclick={() => test(row)}
                  />
                </div>
                <div className="more-info-btn">
                  <Link
                    className="links"
                    to={{
                      pathname: '/dashboard/project',
                      state: { projectId: row.id },
                    }}
                  >
                    <img
                      style={{ cursor: 'pointer' }}
                      src={infoSvgIcon}
                      alt="info"
                    />
                  </Link>
                </div>
              </div>
            )}
          </div>
        );
      },
    },
  ];
  const tableCustomStyles = {
    headCells: {
      style: {
        fontSize: '12px',
        fontWeight: '400',
        justifyContent: 'start',
        lineHeight: '18px',
        fontFamily: 'Inter',
        color: 'rgba(0, 0, 0, 0.40)',
        opacity: 1,
      },
    },
    cells: {
      style: {
        display: 'flex',
        justifyContent: 'start',
      },
    },
  };
  return (
    <>
      <DataTable
        columns={columnss}
        data={latestData}
        responsive
        customStyles={tableCustomStyles}
        // sortIcon={customSortIcon}
        // sortIcon={<SortIcon />}
      />
    </>
  );
};

export default ProjectsPage;
